module.exports = __webpack_public_path__ + "static/media/image002.a3c81fa3.png";